import { render } from "./FootballMetricIcon.vue?vue&type=template&id=23b02443&scoped=true"
import script from "./FootballMetricIcon.vue?vue&type=script&lang=js"
export * from "./FootballMetricIcon.vue?vue&type=script&lang=js"

import "./FootballMetricIcon.vue?vue&type=style&index=0&id=23b02443&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b02443"]])

export default __exports__